import { render } from "./HomeHeader.vue?vue&type=template&id=650b26be"
import script from "./HomeHeader.vue?vue&type=script&lang=js"
export * from "./HomeHeader.vue?vue&type=script&lang=js"

import "./HomeHeader.vue?vue&type=style&index=0&id=650b26be&lang=postcss"
script.render = render

export default script